<div>

@if (donotShow == false) {

  <div style="width: 100%;" [ngStyle]="{'visibility': isContentListVisible ? 'visible' : 'hidden'}">
<div class="content-list-header" (click)="clickOutside()">
  @if (showCloseButton == true) {
    <div class="show-favorites pointer" (click)="closeWindow()">
      <img src="../../assets/x.svg" />
      Close
    </div>
  }
  @if (contextMessage != "") {
    <div class="context-message">
      {{contextMessage}}
    </div>
  }
  <div class="frame-42">
    @if (showOneProjectOnly == true) {
      <div class="show-favorites pointer" (click)="filterByProject()">
        Selected project
      </div>
    } @else {
      <div class="show-favorites pointer" (click)="filterByProject(projectKey)">
        All projects
      </div>
    }
  </div>
  <div class="frame-42">
    @if (showFavouriteOnly == false) {
      <div class="show-favorites pointer" (click)="showFavourite(true)">
        <img src="../../assets/star.svg" class="post-icon" />
         Show all
      </div>
    } @else {
      <div class="show-favorites pointer" (click)="showFavourite(false)">
        <img src="../../assets/star-filled.svg" class="post-icon" />
        Show favorites
      </div>
    }
  </div>
  <div class="position-relative">
      <span (click)="showFilterPopup()" class="button pointer">
        <img class="circle-plus" src="../../assets/filter.svg" />
        <div class="button-label" >
          Filter by
        </div>
        <img class="circle-plus" src="../../assets/chevron-down.svg" />
      </span>
  
      @if (isFilterPopupVisible) {
        <div class="dropdown-content">
          <div class="search-label" (click)="filterPosts()">
            Search knowledge base
          </div>
          <div class="search-input">
            <input type="text" class="input-text" [(ngModel)]="searchQuery" name="searchQuery" (keydown.enter)="searchByFilter()" (ngModelChange)="filterOnInputChange($event)" placeholder="Enter keywords" />
          </div>
          <div class="search-buttons">
            <div class="button3">
              <div class="button-label" (click)="clearSearch()" *ngIf="searchQuery != ''">Clear</div>
            </div>
            <div class="button2" (click)="searchByFilter()">
              <img class="filter" src="../../assets/filter-white.svg" />
              <div class="button-label2">Filter</div>
            </div>
          </div>
        </div>
      }
  </div>
  <div class="button2 pointer" (click)="showAddPostMenu()">
      <img class="circle-plus" src="../../assets/circle-plus.svg"  />
      <div class="button-label2" >Add</div>
      <svg  class="circle-plus" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M4 6.68164L8 10.6816L12 6.68164" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      @if (isAddPostMenuVisible) {
        <div class="dropdown-content">
          @for (template of templates; track template.key) {
            <div class="dropdown-item pointer" (click)="addPost(template.key, true)">
              {{template.name}}
            </div>
          }
        </div>
      }
  </div>
</div>




          <!-- here is the list of posts and filters -->


<div class="content-container">
  <div class="filter-container" (click)="clickOutside()">
    <div class="filter-block">
      <div class="filter-block-header">
        <img src="../../assets/folder.svg" />
        Knowledge types
      </div>
      <div class="knowledge-types">
        @for (type of templates; track type.key) {
          @if (shownTemplates.includes(type.key)) {
            <div class="knowledge-type-selected pointer" (click)="filterByTemplate(type.key)">
              {{type.name}}
            </div>
          } @else {
            <div class="knowledge-type pointer" (click)="filterByTemplate(type.key)">
              {{type.name}}
            </div>
          }
        }
        @if (shownTemplates.length > 0) {
          <div class="knowledge-type pointer" (click)="showAllTemplates()">
            Show all
          </div>
        }
      </div>
    </div>

    <!--div class="filter-block">
      <div class="filter-block-header">
        <img src="../../assets/folder.svg" />
        Personas
      </div>
      <div class="knowledge-types">
        @for (persona of personas; track persona.key) {
          @if (shownPersonas.includes(persona.key)) {
            <div class="knowledge-type-selected pointer" (click)="filterByPersona(persona.key)">
              {{persona.name}}
            </div>
          } @else {
            <div class="knowledge-type pointer" (click)="filterByPersona(persona.key)">
              {{persona.name}}
            </div>
          }
        }
        @if (shownPersonas.length > 0) {
          <div class="knowledge-type pointer" (click)="showAllPersonas()">
            Show all
          </div>
        }
      </div>
    </div-->

  </div>


  <div  class="post-list-container">
  <!-- here is the list of filters applied -->
                  <div class="filters-applied">
                    <div class="frame-137">
                      <div class="frame-133">
                        <img class="filter-icon" src="../../assets/filter.svg" />
                        @if (activeFilters.length > 0) {
                          <div class="filters-applied2">Filters applied:</div>
                        } @else {
                          <div class="filters-applied2">No filters applied</div>
                        }
                      </div>
                      <div class="frame-136">
                        @for (filter of activeFilters; track filter) {
                        <div class="frame-134">
                          <div class="search-tag">
                            <span>
                              <span class="search-tag2">Search: </span>
                              <span class="search-tag3">{{filter.displayName}}</span>
                            </span>
                          </div>
                          <img class="filter-icon pointer" src="../../assets/x.svg" (click)="removeFilter(filter.content)" />
                        </div>
                        }
                      </div>
                      @if (activeFilters.length > 0) {
                        <div class="frame-1352">
                          <div class="clear-all pointer" (click)="clearSearch()">Clear all</div>
                        </div>
                      }
                    </div>
                  </div>
                  @if (posts.length == 0) {
                    @if (postsLoaded == true) {
                      <div class="no-posts-message-container">
                        <img src="../../assets/subtract-color.png" />
                        <div class="no-posts-message">
                          No content found...
                        </div>
                        <div class="no-posts-message-subtext">
                          Try to change the filters or search query.
                        </div>
                      </div>
                    } @else {
                      <div class="no-posts-message-container">
                        <img src="../../assets/subtract-color.png" />
                        <div class="no-posts-message">
                          Content is loading...
                        </div>
                        <div class="no-posts-message-subtext">
                          Please wait.
                        </div>
                      </div>
                    }
                  }

  @if (posts.length > 0) {
  <!-- here is the list of posts -->
  <div class="post-list">
    <!-- Header row -->
    <div class="post-list-header">
      <div class="table-header-column">
        @if (areAllPostsSelected == false) {
          <input type="checkbox" (click)="selectAllPosts()"/>
        } @else {
          <input type="checkbox" (click)="deselectAllPosts()" checked/>
        }
      </div>
      <div class="table-header-column">
        <span class="pointer" (click)="sortPosts('alphabet', true)">
          Name
        </span>
        @if (postsSortedBy == 'alphabet') {
          @if (postsSortedByAscending == false) {
            <img src="../../assets/arrow-up.svg" class="post-icon pointer" (click)="sortPosts('alphabet', true)" />
          } @else {
            <img src="../../assets/arrow-down.svg" class="post-icon pointer" (click)="sortPosts('alphabet', false)" />
          }
        }
      </div>
      <div class="table-header-column">
        <span class="pointer" (click)="sortPosts('project', true)">
          Project
        </span>
        @if (postsSortedBy == 'project') {
          @if (postsSortedByAscending == false) {
            <img src="../../assets/arrow-up.svg" class="post-icon pointer" (click)="sortPosts('project', true)" />
          } @else {
            <img src="../../assets/arrow-down.svg" class="post-icon pointer" (click)="sortPosts('project', false)" />
          }
        }
      </div>
      <div class="table-header-column">
        <span class="pointer" (click)="sortPosts('template', true)">
          Type
        </span>
        @if (postsSortedBy == 'template') {
          @if (postsSortedByAscending == false) {
            <img src="../../assets/arrow-up.svg" class="post-icon pointer" (click)="sortPosts('template', true)" />
          } @else {
            <img src="../../assets/arrow-down.svg" class="post-icon pointer" (click)="sortPosts('template', false)" />
          }
        }
      </div>
      <div class="table-header-column">
        <span class="pointer" (click)="sortPosts('date', true)">
          Modified
        </span>
        @if (postsSortedBy == 'date') {
          @if (postsSortedByAscending == false) {
            <img src="../../assets/arrow-up.svg" class="post-icon pointer" (click)="sortPosts('date', true)" />
          } @else {
            <img src="../../assets/arrow-down.svg" class="post-icon pointer" (click)="sortPosts('date', false)" />
          }
        }
      </div>
      <div></div>
    </div>
  
    <!-- Rows -->
    @for (post of posts; track post; let postIndex = $index) {
      <div class="post-item" [ngStyle]="{ 'border-top': post.color !== '#ffffff' ? '3px solid ' + post.color : ''}">
        <div class="post-checkbox table-header-item">
          @if (post.isSelected == true) {
            <input type="checkbox" checked (click)="deselectContent(post.key)"/>
          } @else {
            <input type="checkbox" (click)="selectContent(post.key)"/>
          }
        </div>
        
        @if (post.templateKey != "document") {
          <div class="post-name pointer" (click)="openPostPanel(post.key, false, post.templateKey, post)">
            <!--
                        @if (post.coverImageURL != undefined && post.coverImageURL != '') {
              <img src="{{post.coverImageURL}}" class="post-list-image-container"  />
          } -->
                          @if (post.templateKey == "canvas") {
              <img src="../../assets/hierarchy-2.svg" class="post-list-image-container" alt="Opportunity Solution Tree" />
            }


            {{post.name.substring(0, 100)}}
          </div>
        } @else {
          <div class="post-name pointer" (click)="loadDocument(post.imageURLs[0].url)">
            <!-- 
                        @if (post.coverImageURL != undefined && post.coverImageURL != '') {
              <img src="{{post.coverImageURL}}" class="post-list-image-container"  />
            }
            -->
            @if (post.fileType.startsWith("video")) {
              <img src="../../assets/videofile.svg" class="post-list-image-container" alt="Video" />
            }
            @else if (post.fileType.startsWith("audio")) {
              <img src="../../assets/speakerfile.svg" class="post-list-image-container" alt="Audio" />
            }
            @else if (post.fileType.startsWith("application/vnd.openxmlformats-officedocument.wordprocessing") || post.fileType.startsWith("application/msword")) {
              <img src="../../assets/word-50.png" class="post-list-image-container" alt="Word file" />
            } 
            @else if (post.fileType.startsWith("application/vnd.openxmlformats-officedocument.spreadsheet") || post.fileType.startsWith("application/vnd.ms-excel")) {
              <img src="../../assets/spreadsheet-50.png" class="post-list-image-container" alt="Excel file" />
            } 
            @else if (post.fileType.startsWith("application/vnd.openxmlformats-officedocument.presentation") || post.fileType.startsWith("application/vnd.ms-powerpoint")) {
              <img src="../../assets/presentation-50.png" class="post-list-image-container" alt="PowerPoint file" />
            } 
            @else {
              <img src="../../assets/document.svg" class="post-list-image-container" alt="Document" />
            }
          {{post.name.substring(0, 100)}}
        </div>
      }
  
      <div class="post-project">
          <div class="project-name">{{post.projectName}}</div>
      </div>
  
      <div class="post-type">
          @if (post.templateKey != "canvas") {
            <div class="project-name">
              {{post.templateName}}
            </div>
          }
          @if (post.templateKey == "canvas") {
            Canvas
          }
          @if (post.isFavourite == true) {
            <img src="../../assets/star-filled.svg" class="post-icon pointer" (click)="toggleFavorite(post.key)" />
          } @else {
            <img src="../../assets/star.svg" class="post-icon pointer" (click)="toggleFavorite(post.key)" />
          }
          @if (post.isTop == true) {
            <img src="../../assets/uparrow.svg" class="post-icon pointer" (click)="togglePin(post.key)" />
          }
          @if (post.isRead == true) {
            <img src="../../assets/downarrow.svg" class="post-icon pointer" (click)="toggleRead(post.key)" />
          }
        </div>
        <div class="post-type">
          <img src="../../assets/calendar.svg" class="post-icon" />
          <div class="project-name">{{post.dateOfUpdate | date:'dd.MM.yyyy'}}</div>
        </div>
        <div class="post-action">
          <img src="../../assets/dots-vertical.svg" class="post-icon pointer" (click)="showPostContextMenu($event, postIndex)" />

        </div>

      </div>
    }
  </div>
  }
  </div>
</div>







@if (itemIndexContextMenu != -1) {
  <div class="dropdown-content" [ngStyle]="{'top.px': menuY, 'left.px': menuX}">
    @if (selectedPost.fileType.startsWith("audio") || selectedPost.fileType.startsWith("video")) {
      <div class="dropdown-item pointer" (click)="extractTextFromAudio(selectedPost.imageURLs[0].url, selectedPost.fileType)">
        Extract text
      </div>
    }
    @if (selectedPost.contentType != "Document") {
      <div class="dropdown-item pointer" (click)="openPostPanel(selectedPostKey, false, selectedPostTemplateKey, selectedPost)">
        Open post
      </div>
    }
    <!--div class="dropdown-item pointer" (click)="setColorClicked()">
      Change color
      @if (isColorPalleteVisible) {
        <color-circle [color]="post.color" [colors]="colors" (onChange)="changeColorComplete($event, post.key)"></color-circle>
      }
    </div-->
    <div class="dropdown-item pointer" (click)="toggleFavorite(selectedPostKey)">
      Mark as favorite
    </div>
    <div class="dropdown-item pointer" (click)="togglePin(selectedPostKey)">
      Pin to top
    </div>
    <div class="dropdown-item pointer" (click)="toggleRead(selectedPostKey)">
      Mark as read
    </div>
    @if (selectedTemplateKey == "document") {
      <div class="dropdown-item pointer" (click)="deleteDocument(selectedPostKey)">
        Delete document
      </div>
    }
    @if (selectedTemplateKey != "canvas" && selectedTemplateKey != "document") {
      <div class="dropdown-item pointer" (click)="deletePost(selectedPostKey)">
        Delete post
      </div>
    }
  </div>
}






@if (projectIsDeleted == true) {
  <div class="container my-5">
    <p class="display-6">
      The project is deleted or something went wrong. Either way you cannot access it anymore.
    </p>
    <p class="display-6">
      If you don't have access to any project, you should add the first one in Wroolo administration panel or ask another user for access to the existing project.
    </p>
    <p class="display-6">
      Click here to see the list of your projects
      <i class="bi bi-list-task pointer" routerLink="/startscreen"></i>
    </p>
  </div>
}


<pdf-viewer
id="pdf-viewer"
[src]="pdfSrc"
[rotation]="0"
[original-size]="false"
[show-all]="true"
[fit-to-page]="false"
[zoom]="1"
[zoom-scale]="'page-width'"
[stick-to-page]="false"
[render-text]="true"
[external-link-target]="'blank'"
[autoresize]="true"
[show-borders]="false"
(after-load-complete)="afterLoadComplete($event)"
class="viewer-window"></pdf-viewer>

<div class="slide-panel" [class.open]="isPostPanelOpen">

  @if (selectedPostKey != "" && isPostPanelOpen == true) {
    <app-detailsforpage
      [postKey]="selectedPostKey"
      [organizationKey]="organizationKey"
      [projectKey]="projectKey"
      [isNewPost]="false"
      [userId]="userId"
      [type]="type"
      [post]="post"
      [fields]="post.fields"
      [projectName]="projectName"
      [isAnonymous]="isAnonymous"
      [isReadOnly]="isReadOnly"
      [launchedAsSubcomponent]="false"
      [columnKey]="columnKey"
      [color]="color"
      [areKidsColored]="areKidsColored"
      [areKidsTagged]="areKidsTagged"
      [isCompleted]="isCompleted"
      [isDeleted]="isDeleted"
      [imageURLs]="imageURLs"
      [isFavourite]="isFavourite"
      [isReadOnly]="isReadOnly"
      [isRead]="isRead"
      [isTop]="isTop"
      [templateKey]="templateKey"
      [userDisplayName]="userDisplayName"
      [embeddingModel]="embeddingModel"
      [captureImage]="captureImage"
      [launchedAsDialog]="site == 'wroolo' ? true : false"
      [startDate]="startDate"
      [endDate]="endDate"
      [manHours]="manHours"
      [progressPercent]="progressPercent"
      [templates]="templates" 
      [canvasKey]="selectedPostKey"

    (listenContent)="onListenContent($event)"
    (closePopup)="close($event)" 
    (sendStatusUpdate)="updateStatus($event)"
    (sendColorUpdate)="updateColor($event)"
    (sendNameUpdate)="updateName($event)"
    (sendIsComplete)="updateComplete($event)"
    (sendDelete)="updateDelete($event)"
    (sendCoverImageUpdate)="updateCoverImage($event)">
  </app-detailsforpage>
}
</div>

</div>
}

@if (userId == "ritHfncGyKdlmuPUApEkHFfPff13" && false) {
<!--div *ngIf="!isLoggedIn">
  <button (click)="handleSignIn()">Sign In with Google</button>
</div>

<div *ngIf="isLoggedIn && showPicker">
  <drive-picker client-id="clientId" oauth-token="userAccessToken">
    <drive-picker-docs-view starred="true"></drive-picker-docs-view>
  </drive-picker>
</div-->

@if (isCreatingOntologies == true) {
  <div class="loading-container">
    <div class="loading-spinner"></div>
    <div class="loading-text">Thinking...</div>
  </div>
}

@if (isCreatingOntologies == false) {
  <button (click)="createOntologiesClientSide()">Create ontologies</button>
  <!--button (click)="conductReasoning()">Conduct reasoning</button-->
    <button (click)="createOntologyEmbeddings(1)">Create embeddings</button>
    <button (click)="createStatements()">Create statements</button>
    <button (click)="deduce(2, 32, 0.8)">Deduce</button>
    <button (click)="exportOntologiesToFile(1, 42)">Export ontologies</button>
    <button (click)="deleteOntologyStatementsByIteration(-1, 42)">Delete ontologies</button>
} 

<app-proofstatement [organizationKey]="organizationKey" [threshold]="0.8" [minScore]="0.5"></app-proofstatement>
<!--button (click)="addOrganizationContentTemplateNyKey('outcome')">Add organization content template</button-->
}

@if (showFileDropPopup == true) {
  <div class="drop-files-popup">
    <app-filedrop-popup (fileDropped)="onFileDropped($event, false)" [message]="dropFilesMessage" (hideDropPopup)="hidePostContextMenu()">
    </app-filedrop-popup>
  </div>
}

</div>